// Modules
import axios from 'axios';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

// CSS
import '_Asset/css/Admin/Page/admin.css'

// Component
import { Pagination } from 'User/Component';
import {
  Paging, // Paging
  CurPageList, // 전체 리스트 정렬 및 현재 페이지 리스트 출력
  SetSortIco, // 정렬 아이콘 변경
  HandleSingleCheck, HandleAllCheck, // 체크박스 단일, 전체 선택
} from 'Admin/Component/AdFunc';

// API
import { CmApi, CmUseApi } from '_Route/Api';
import Loading from 'Admin/Component/Loading';


const AdCustomer = () => {

  // Using Hooks
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [guideStatus, setGuideStatus] = useState(true);
  const [customerData, setCustomerData] = useState({
    pageList: [], // Customer Page List
    resList: [], // Customer Result List
  })
  const { pageList, resList } = customerData

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);
  // const userRoles = useSelector(state => state.authorityAcc.roles);

  // 필터 옵션
  const [filterOpt, setFilterOpt] = useState({
    search_key: '',
    search_val: params.key || '',
    cust_fjoin: '',
    cust_ljoin: '',
  })
  const { search_key, search_val, cust_fjoin, cust_ljoin } = filterOpt;
  
  // Paging var
  const [curPage, setCurPage] = useState(1) // 현제 페이지
  const [blockSize, setBlockSize] = useState(10) // Pagination 블럭 갯수
  const [pageSize, setPageSize] = useState(10) // 한 페이지에 노출할 고객 갯수
  const [count, setCount] = useState('');

  // Column name / Sort var
  const columnList = [
    {name: 'No', key: 'cust_no'},
    {name: '업체명', key: 'cust_corp'}, 
    {name: '이메일', key: 'cust_email'},
    {name: '이름', key: 'cust_name'},
    {name: '연락처', key: 'cust_tel'},
    {name: '등록일', key: 'cust_fjoin'},
    {name: '최근 접속일', key: 'cust_ljoin'},
    {name: '수정', key: 'cust_use', access_score: 300},
  ]; 
  
  const [sortIdx, setSortIdx] = useState(0);
  const [sortType, setSortType] = useState('');
  const [sortState, setSortState] = useState('expand'); // expand, up(DECS), down(ASC);

  // CheckBox var
  const [checkItems, setCheckItems] = useState([]);


  /*========================================================================
  * onHandler Func
  ========================================================================*/
  const onFilter = (e) => {
    const { name, value } = e.target;
    setFilterOpt({...filterOpt, [name]: value});
  }
  
  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    navigate(`/admin/customer-mgt/list${search_val === '' ? '' : '/' + encodeURIComponent(search_val)}`);
  }


  /* ========================================================================
  * Axios Customer
  ========================================================================*/
  const [update, setUpdate] = useState(false); // 리스트 상태 업데이트 변수 

  // GET Customer List
  useEffect(() => {
    setLoading(false)
    axios.get(CmApi, {
      params: filterOpt,
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      // console.log("GET Customer List Success!", res);
      const sortData = res.data.result;
      
      customerData.pageList = res.data.pageInfo
      customerData.resList = CurPageList(sortData, sortType, sortState, curPage, pageSize)
      setCustomerData({...customerData})
      setCount(res.data.result.length);
    })
    .catch(err => {
      console.error("GET Customer List ERROR...", err);
    })
    .finally(() => {
      setLoading(true)
    })
  }, [location, pageSize, curPage, sortState, sortIdx, update, search_key, cust_fjoin, cust_ljoin])
  
  // PUT Customer
  const UpdateCust = (custUuid) => {
    axios({
      url: CmUseApi,
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        cust_uuid: custUuid,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      // console.log("PUT Customer List Success!", res)
      alert(`고객 계정 사용 여부 변경${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      setUpdate(!update)
    })
    .catch(err => {
      console.error("PUT Customer List ERROR...", err);
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }
  // DELETE Customer
  const DeleteCust = (custUuid, index) => {
    axios({
      url: CmApi,
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        cust_uuid: custUuid,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      if(index === checkItems.length - 1) {
        alert(`${checkItems.length}개의 고객 계정 삭제${master === 1 ? '를' : ' 요청을'} 완료하였습니다.`)
      }
      setUpdate(!update)
    })
    .catch(err => {
      // console.error("DELETE Customer List ERROR...", err);
      const errMsg = err.response.data.message
      if (errMsg && index === 0) { alert(errMsg); }
    })
  }
  
  // 일괄 삭제 함수
  const deleteFunc = () => {
    if(checkItems.length === 0) {
      alert('삭제할 고객을 선택해주세요.')
    } else {
      if(window.confirm(`${checkItems.length}개의 고객 계정을 선택하셨습니다. \n정말 삭제${master === 1 ? '' : '를 요청'}하시겠습니까?`)) {
        checkItems.map((id, i) => { DeleteCust(id, i) })
        setCheckItems([])
      }
    }
  }
  
  
  return (
    <>
      <div className="adContTitGroup">
        <h2>고객 관리</h2>
        <p>Home / 고객 관리 <button type="button" onClick={() => setGuideStatus(!guideStatus)}><i className="icofont-info-circle" /> 가이드 {guideStatus ? '접기' : '보기'} <i className={`icofont-rounded-${guideStatus ? 'up' : 'down'}`} /></button></p>

        <ul className={`subMsg ${guideStatus ? '' : 'off'}`}>
          <li>* 개발자 포탈의 고객 계정을 <span className="blueTxt">조회/관리</span>할 수 있습니다.</li>
          <li>* 고객 등록 버튼을 통해 <span className="blueTxt">새로운 고객 계정 등록</span>이 가능합니다.</li>
          <li>* 고객 계정의 비밀번호는 임시 비밀번호로 생성 후, 추후 고객이 로그인시 비밀번호를 변경하는 방식으로 운영됩니다.</li>
        </ul> 
      </div>

      <div className="adContArea list">

        <div className="flexBox between">
          <div className="adListBox">
            {
              userScore >= 300 &&
              <button type="button" className="btn xs red round_10" onClick={deleteFunc}>선택 삭제</button>
            }
            
            <div className="fieldGroup">
              <label>노출 고객 수</label>

              <div className="field">
                <select className="select sm type_1 round_10" onChange={(e) => setPageSize(e.target.value)} defaultValue="10">
                  <option value="10">10개 씩</option>
                  <option value="30">30개 씩</option>
                  <option value="50">50개 씩</option>
                  <option value="100">100개 씩</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>등록일</label>

              <div className="field">
                <select className="select sm type_1 round_10" name="cust_fjoin" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>최근 접속일</label>

              <div className="field full">
                <select className="select sm type_1 round_10" name="cust_ljoin" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>
          </div>

          <div className="adListBox">
            <div className="fieldGroup row gap">
              <label>고객 검색</label>

              <div className="field gap">
                <select className="select sm type_1 round_10" name="search_key" onChange={(e) => onFilter(e)}>
                  <option value="">통합검색</option>
                  <option value="cust_corp">업체명</option>
                  <option value="cust_email">이메일</option>
                  <option value="cust_name">이름</option>
                  <option value="cust_tel">연락처</option>
                </select>
                <div className="inputIco">
                  <input type="text" className="input sm type_1 i_rt round_10" name="search_val" value={search_val} onChange={(e) => onFilter(e)} onKeyPress={onKeyPress} placeholder="검색어를 입력해주세요." />
                  <button type="button" className="icofont-search" onClick={onSearch}></button>
                </div>
              </div>
            </div>

            {
              userScore >= 200 &&
              <button type="button" className="btn xs sfrtBlue round_10" onClick={() => navigate('/admin/customer-mgt/view/add')}>고객 등록</button>
            }
          </div>
        </div>

        <div className="table list_2">
          <table>
            <thead>
              <tr>
                <th className="check">
                  <div className="checkGroup">
                    <input type="checkbox" className='check sm blue' id="allCheck" onChange={(e) => setCheckItems(HandleAllCheck(e.target.checked, resList, 'cust_uuid'))} checked={checkItems.length === resList.length ? true : false}/>
                    <label htmlFor="allCheck"></label>
                  </div>
                </th>
                {columnList.map((list, i) =>
                  (userScore >= list?.access_score || /* userRoles === list?.roles || */ list.access_score === undefined) &&
                  <th key={i} onClick={() => {setSortState(SetSortIco(i, sortIdx, sortState)); setSortIdx(i); setSortType(list.key)}}>{list.name}<i className={`icofont-rounded-${i === sortIdx ? sortState : 'expand'}`}></i></th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ?
                resList.length !== 0 ?
                  resList.map((data, i) => 
                    <tr key={i}>
                      <td>
                        <div className="checkGroup">
                          <input type="checkbox" className='check sm blue' id={`check_${i}`} onChange={(e) => setCheckItems(HandleSingleCheck(e.target.checked, data.cust_uuid, checkItems))} checked={checkItems.includes(data.cust_uuid) ? true : false}/>
                          <label htmlFor={`check_${i}`}></label>
                        </div>
                      </td>
                      <td>{data.cust_no}</td>
                      <td>{data.cust_corp}</td>
                      <td>{data.cust_email}</td>
                      <td>{data.cust_name}</td>
                      <td>{data.cust_tel}</td>
                      <td>{moment(data.cust_fjoin).format('YYYY-MM-DD HH:mm')}</td>
                      <td>{moment(data.cust_fjoin).format('YYYY-MM-DD HH:mm')}</td>
                      {
                        (userScore >= 300/*  || userRoles === 2 */) &&
                        <td style={{width: '125px'}}>
                          <div className="btnArea col full">
                            <button type="button" className={`btn xxs ${data?.cust_use === 1 ? 'sfrtBlue' : 'blue_edge'} round_10`} onClick={() => UpdateCust(data.cust_uuid)}>{data?.cust_use === 1 ? '사용' : '미사용'}</button>
                            <button type="button" className="btn xxs green round_10" onClick={() => navigate(`/admin/customer-mgt/view/${data.cust_uuid}`)}>고객 수정</button>
                          </div>
                        </td>
                      }
                    </tr>
                  )
                  :
                  <tr>
                    <td colSpan={columnList.length + 1}>
                      <div className="noData">
                        <i className="icofont-warning-alt"></i>
                        <p>데이터가 존재하지 않습니다.</p>
                      </div>
                    </td>
                  </tr>
                :
                <tr><td colSpan={columnList.length + 1}><Loading type="tbLoad" /></td></tr>
              }
            </tbody>
          </table>
        </div>

        <div className="flexBox between paginationBox">
          <p>Showing {curPage} to {pageSize} of {pageList.count} entries</p>

          <Pagination
            type="type_1"
            size="sm"
            curPage={curPage}
            setCurPage={setCurPage}
            pageSize={pageSize}
            blockSize={blockSize}
            startBlock={Paging(curPage, blockSize, pageSize, count).startBlock}
            endBlock={Paging(curPage, blockSize, pageSize, count).endBlock}
            pageCount={Paging(curPage, blockSize, pageSize, count).pageCount}
          />
        </div>
      </div>
    </>
  )
}

export default AdCustomer;